import styled from 'styled-components';

export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-top: 1rem;
  padding: 1rem 1.25rem;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  h6 {
    margin: 0;
    font-weight: 600;
    color: #495057;
    font-size: 0.95rem;
  }
`;

export const IconWrapper = styled.div`
  color: #0d6efd;
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
  font-size: 1.1rem;
`;

export const MappingRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`;

export const MappingInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const Badge = styled.span`
  background: ${({ variant }) =>
    variant === 'origin'
      ? '#e9f2ff'
      : variant === 'destination'
      ? '#e6f4ea'
      : '#f1f3f5'};
  color: ${({ variant }) =>
    variant === 'origin'
      ? '#0d6efd'
      : variant === 'destination'
      ? '#2e7d32'
      : '#495057'};
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.35rem 0.6rem;
  border-radius: 8px;
`;

export const ValuePreviewWrapper = styled.div`
  display: flex;
  align-items: center;

  small {
    color: #6c757d;
    margin-right: 0.5rem;
  }
`;
